<template>
  <component
    :is="rootComponent"
    class="flex w-full cursor-pointer items-center justify-between space-x-3 bg-background p-3"
    v-bind="componentProps"
  >
    <div
      class="flex size-8 items-center justify-center rounded-md p-1"
      :class="
        {
          warning: 'bg-warning',
          primary: 'bg-primary',
        }[color]
      "
    >
      <slot name="icon">
        <component
          :is="icon"
          class="size-full text-background"
        />
      </slot>
    </div>

    <div class="flex-1">
      <p class="line-clamp-1 text-left text-lg font-medium">
        <slot name="label">
          {{ label }}
        </slot>
      </p>
    </div>

    <div class="flex h-full items-center justify-center">
      <IconChevronRight
        class="size-6 text-background-fg/20"
      />
    </div>
  </component>
</template>

<script setup lang="ts">
import type { Component } from "vue"
import type { RouteLocationRaw } from "vue-router"

const props = withDefaults(
  defineProps<{
    icon?: Component
    label?: string
    description?: string
    to?: RouteLocationRaw
    color?: "primary" | "warning"
  }>(),
  {
    icon: undefined,
    label: undefined,
    description: undefined,
    to: undefined,
    color: "primary",
  }
)

const rootComponent = computed(() =>
  props.to ? "RouterLink" : "button"
)

const componentProps = computed(() =>
  rootComponent.value === "button" ? { type: "button" } : {}
)
</script>
